import Reveal from './ui/Reveal';

export default function CoreProblem() {
  return (
    <section className="alt">
      <div className="wrap">
        <Reveal className="narrow center">
          <span className="eyebrow">The core problem</span>
          <h2 className="h-sec">
            <span className="dim">Information is everywhere.</span> Confidence is rare.
          </h2>
          <p className="lede mt-m">
            Books, videos, webinars, technical manuals, and AI have made LNG information more
            accessible than ever. Yet many capable professionals still freeze in interviews, hesitate
            during technical discussions, and struggle to demonstrate the level of confidence the
            industry expects.
          </p>
          <p className="lede mt-s">
            The challenge isn&rsquo;t access to information. It&rsquo;s developing the{' '}
            <b style={{ color: 'var(--ink)', fontWeight: 600 }}>
              technical judgment, confidence, and ability to apply that knowledge
            </b>{' '}
            when it matters most. That&rsquo;s exactly what LNG Ready is designed to help you build.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
